import {Button, Form, Input, Space} from "antd";
import {useTranslation} from "react-i18next";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useRef} from "react";

export default function HospitalFilter()
{
    const {t} = useTranslation();
    const {onFilterPageSort} = useDataGrid();
    const formRef = useRef();

    const reset = () => {
        formRef.current.resetFields();
        onFilterPageSort({
            filter: {}
        })
    }

    const filter = (form) => {
        onFilterPageSort({
            filter: form
        })
    }

    return (
        <>
            <Form
                ref={formRef}
                onFinish={filter}
                layout={'vertical'}
            >
                <Space style={{marginBottom: 16}}>
                    <Button type={'primary'} size={'small'} htmlType="submit" >{t('Search')}</Button>
                    <Button size={'small'} onClick={reset}>{t('Reset')}</Button>
                </Space>
                <Form.Item
                    label={t('Search')}
                    name={'searchText'}
                >
                    <Input placeholder={t('Name or Official Name')} allowClear />
                </Form.Item>
                <Form.Item
                    label={t('Key')}
                    name={'key'}
                >
                    <Input allowClear />
                </Form.Item>
            </Form>
        </>
    )
}
